import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@folio/stripes/components';
import { useStripes } from '@folio/stripes/core';
var RULES_PATH = '/czna-authorities/validation-rules';
var READ_PERM = 'czna-authorities.validation.rules.read';
/**
 * Footer-pinned nav button for the validation-rule administration screen
 * (CZNA-245). Mirrors `SettingsNavButton`. Gated by the `read` permission so
 * only operators who can view rules see the entry (UX gate; server enforces).
 */
var ValidationRulesNavButton = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var stripes = useStripes();
    var handleClick = useCallback(function () {
        if (pathname !== RULES_PATH)
            history.push(RULES_PATH);
    }, [history, pathname]);
    if (!stripes.hasPerm(READ_PERM))
        return null;
    var isActive = pathname === RULES_PATH || pathname.startsWith("".concat(RULES_PATH, "/"));
    return (React.createElement(Button, { onClick: handleClick, buttonStyle: isActive ? 'primary' : 'default', fullWidth: true, marginBottom0: true, style: { justifyContent: 'flex-start' }, "aria-current": isActive ? 'page' : undefined },
        React.createElement("span", { style: { marginLeft: '0.5rem' } }, intl.formatMessage({ id: 'ui-czna-authorities.navigation.validationRules' }))));
};
export default ValidationRulesNavButton;
